// extracted by mini-css-extract-plugin
export default {"this":"Card_this__QiyvC","name":"Card_name__MO+qG","description":"Card_description__DfExi"};